import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import "./App.css";
import Home from "./components/Home";
import Login from "./components/Login";
import SignUp from "./components/SignUp";
import PendingApproval from "./components/PendingApproval";
import Navbar from "./components/Navbar";
import AdminDashboard from "./components/admin/AdminDashboard";
import StudentDashboard from "./components/StudentDashboard";
import ProtectedRoute from "./components/ProtectedRoute";
import AllBatches from "./components/AllBatches";

function App() {
  return (
    <Router>
      <div className="min-h-screen">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/batches" element={<AllBatches />} />
          <Route path="/login" element={<Login />} />
          <Route path="/signup" element={<SignUp />} />

          <Route path="/pending-approval" element={<PendingApproval />} />
          <Route path="/student-dashboard" element={<StudentDashboard />} />

          {/* {/* Protected Admin Routes */}
          <Route element={<ProtectedRoute />}>
            <Route path="/admin/*" element={<AdminDashboard />} />
            <Route path="/student-dashboard/*" element={<StudentDashboard />} />
          </Route>

          {/* 404 Page */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
